import { t } from "i18next";
import { useEffect } from "react";
import { useFetch } from "../../../../../hooks/useFetch";
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription, AlertDialogCancel } from "../../../../../ui/AlertDialog/AlertDialog";
import { Button } from "../../../../../ui/Button";

type Props = {
  sensorId: string;
  equipmentId: string;
  isDeleteOpen: boolean;
  closeModal: Function;
  updateList: Function;
};

const DeleteDevice = ({ sensorId, equipmentId, isDeleteOpen, closeModal, updateList }: Props) => {
  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] =
    useFetch(`/directories/equipment_items/${equipmentId}/sensors/${sensorId}`);

  useEffect(() => {
    if (isDeleteOpen) {
      updateList();
      closeModal();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }} className="gap-0">
        <AlertDialogTitle>Удалить устройство</AlertDialogTitle>
        <AlertDialogDescription className="text-base">Вы уверены, что хотите удалить устройство?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">
            {t("cancel")}
          </AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteDevice;
